export const replaceUrlWithHttps = (currentValue: string): { url: string; protocol: 'https://' | 'http://' | '' } => {
	if (currentValue.startsWith('https://')) {
		return { url: currentValue.replace('https://', ''), protocol: 'https://' };
	}

	if (currentValue.startsWith('http://')) {
		return { url: currentValue.replace('http://', ''), protocol: 'http://' };
	}

	return { url: currentValue, protocol: '' };
};
